import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { base64StringToBlob } from 'blob-util';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { AnnotationApiService } from '../../data-services/index';

import { IAnnotation } from '@ebb-v2/ebb-integration';

export interface IDialogViewData {
  annotationId: string;
  viewType: number; // [1 = document | 2 = image]
  title:string
}

@Component({
  selector: 'ebb-portal-dialog-view',
  templateUrl: './dialog-view.component.html'
})
export class DialogViewComponent implements OnInit {
  public title = 'View file' + (this.data.title ? ': ' + this.data.title : '');
  public fileRead = false;
  public fileUrl: any;
  public imageWidth = 100;
  public imageRotationAmount = 0;
  public imageTransform: string;

  constructor(
    public dialogRef: MatDialogRef<DialogViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogViewData,
    private apiAnnotation: AnnotationApiService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.getSubmittedFile();
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  zoomInImage(): void {
    this.imageWidth += 40;
  }

  zoomOutImage(): void {
    if(this.imageWidth > 40) {
      this.imageWidth -= 40;
    }
  }

  rotateImage(direction) {
    this.imageRotationAmount += direction === 'left' ? -90 : 90;
    this.imageTransform = `rotate(${this.imageRotationAmount}deg)`;
  }

  public getSubmittedFile() : void {
    this.fileRead = false;
    if (this.data.annotationId && this.data.annotationId.length > 0) {
      this.apiAnnotation.getAnnotation(this.data.annotationId)
        .subscribe(
          data => {
            this.createImageFromBlob(data);
          },
          error => {
            console.log(error);
          }
        );
    }
  }

  public createImageFromBlob(loadFile: IAnnotation) {
    const reader = new FileReader();

    const fileBlob = base64StringToBlob(loadFile.documentBody, loadFile.mimeType);

    reader.addEventListener('load', () => {
      if (this.data.viewType === 1) {
        if (typeof(reader.result) === 'string')
          this.fileUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(reader.result);
      }
      else {
        this.fileUrl = reader.result;
      }
      
    }, false);

    reader.readAsDataURL(fileBlob);
    this.fileRead = true;
  }
}
